import { render, staticRenderFns } from "./TurnAuthorization.vue?vue&type=template&id=3910c77a&"
import script from "./TurnAuthorization.vue?vue&type=script&lang=js&"
export * from "./TurnAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports